import { render, staticRenderFns } from "./IntegrationService.vue?vue&type=template&id=1af15e2a&scoped=true&"
import script from "./IntegrationService.vue?vue&type=script&lang=js&"
export * from "./IntegrationService.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationService.vue?vue&type=style&index=0&id=1af15e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af15e2a",
  null
  
)

export default component.exports